import type { Step } from 'react-joyride';

/**
 * Tutorial tour steps for the KPI Portal.
 * Covers the main employee flow: navigation → Dashboard → Assignments.
 *
 * Each step's `data.page` property indicates which route the step belongs to.
 * The TutorialProvider will navigate there before showing the step.
 */

export const TOUR_STEPS: (Step & { data?: { page?: string } })[] = [
  // ── Welcome ──
  {
    target: '.topbar h1',
    title: 'Welcome to the KPI Portal!',
    content:
      'This guided tour will walk you through the key areas of the app. You can restart it any time by clicking the "?" button in the top-right corner.',
    placement: 'bottom',
    disableBeacon: true,
    data: { page: '/dashboard' },
  },

  // ── Navigation ──
  {
    target: '.topbar nav',
    title: 'Navigation',
    content:
      'Use the navigation bar to switch between pages — Dashboard for an overview, Assignments to manage and rate your KPIs, and Team if you are a manager.',
    placement: 'bottom',
    disableBeacon: true,
    data: { page: '/dashboard' },
  },

  // ── Dashboard cards ──
  {
    target: '.card-grid',
    title: 'Performance Snapshot',
    content:
      'The Dashboard shows summary cards for your KPI count, average score, completion rate, and more — giving you a quick view of how you are doing.',
    placement: 'bottom',
    disableBeacon: true,
    data: { page: '/dashboard' },
  },

  // ── Navigate to Assignments ──
  {
    target: '[href="/assignments"]',
    title: 'Assignments Page',
    content:
      'Click here to go to the Assignments page where you can see all your KPIs, rate yourself, and view manager ratings.',
    placement: 'bottom',
    disableBeacon: true,
    data: { page: '/dashboard' },
  },

  // ── Performance rings ──
  {
    target: '.sd',
    title: 'Performance Dashboard',
    content:
      'This dashboard shows your Self Score, Manager Score, and overall Outcome as ring charts — plus a breakdown of each KPI below.',
    placement: 'bottom',
    disableBeacon: true,
    data: { page: '/assignments' },
  },

  // ── KPI table ──
  {
    target: '.sd-tiles',
    title: 'Your KPI Tiles',
    content:
      'Each tile represents one of your assigned KPIs. You can see the weight, scores, and status at a glance.',
    placement: 'top',
    disableBeacon: true,
    data: { page: '/assignments' },
  },

  // ── Account / auth ──
  {
    target: '.auth',
    title: 'Your Account',
    content:
      'Here you can see who you are logged in as, and log out when you are done. That\'s the basics — enjoy using the KPI Portal!',
    placement: 'bottom-end',
    disableBeacon: true,
    data: { page: '/assignments' },
  },
];
